import {GanttChartLegend} from '@hconnect/ganttchart/src/modules/GanttChartLegend'
import {LegendItemType} from '@hconnect/ganttchart/src/modules/GanttChartLegend/components'
import {useTranslation} from 'react-i18next'

import {kilnColors} from '@refra/modules/refra-planning/helpers/mapColorConfig'

interface ChartLegend {
  displayItems: ChartLegendItems[]
  translationKey?: string
}

type ChartLegendItems =
  | 'tires'
  | 'drive'
  | 'mortar'
  | 'threshold'
  | 'drillingInfo'
  | 'drillingCritical'

export const ChartLegend = ({displayItems, translationKey}: ChartLegend) => {
  const {t} = useTranslation()

  const availableChartLegendItems: Record<ChartLegendItems, LegendItemType> = {
    tires: {
      id: 'tires_legend',
      label: t(`${translationKey}.chartLegend.tires`),
      indicator: {
        height: 12,
        style: {
          border: `1px solid ${kilnColors.outline}`,
          backgroundColor: kilnColors.station
        }
      }
    },
    drive: {
      id: 'drive_legend',
      label: t(`${translationKey}.chartLegend.drive`),
      indicator: {
        height: 12,
        style: {
          border: `1px solid ${kilnColors.outline}`,
          backgroundColor: kilnColors.drive
        }
      }
    },
    mortar: {
      id: 'mortar_legend',
      label: t(`${translationKey}.chartLegend.mortar`),
      indicator: {
        height: 12,
        style: {
          border: `1px solid ${kilnColors.outline}`,
          backgroundColor: kilnColors.mortar
        }
      }
    },
    threshold: {
      id: 'threshold_legend',
      label: t(`${translationKey}.chartLegend.threshold`),
      children: (
        <div
          key={'threshold_line'}
          className={'h-0'}
          style={{borderTop: '2px dashed red', width: '20px'}}
        />
      )
    },
    drillingInfo: {
      id: 'drilling_info_legend',
      label: t(`${translationKey}.chartLegend.drillingInfo`),
      children: <div key={'threshold_line'} className={'w-2 h-2 bg-foreground_faded rotate-45'} />
    },
    drillingCritical: {
      id: 'drilling_critical_legend',
      label: t(`${translationKey}.chartLegend.drillingCritical`),
      children: <div key={'threshold_line'} className={'w-2 h-2 bg-negative rotate-45'} />
    }
  }

  return (
    <GanttChartLegend legendItems={displayItems.map((item) => availableChartLegendItems[item])} />
  )
}
